import { Truck, Container, Ship } from 'lucide-react';
import { motion } from 'framer-motion';

const services = [
  {
    icon: Truck,
    title: 'Freight Brokerage',
    description: 'FTL, LTL & Expedited',
  },
  {
    icon: Container,
    title: 'Equipment Transport',
    description: 'Heavy machinery & oversized loads',
  },
  {
    icon: Ship,
    title: 'Port & Export Coordination',
    description: 'Domestic transport to ports',
  },
];

export const ServicesStrip = () => {
  return (
    <section data-testid="services-strip" className="bg-white py-16 lg:py-20 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              data-testid={`service-strip-card-${index}`}
              className="flex items-center gap-5 group"
            >
              <div className="w-16 h-16 lg:w-20 lg:h-20 rounded-lg bg-navy-900 flex items-center justify-center flex-shrink-0 group-hover:bg-orange-500 transition-colors duration-300">
                <service.icon className="w-8 h-8 lg:w-10 lg:h-10 text-white" />
              </div>
              <div>
                <h3 className="font-heading text-xl lg:text-2xl font-bold text-navy-900 uppercase">
                  {service.title}
                </h3>
                <p className="font-body text-sm lg:text-base text-slate-600 mt-1">
                  {service.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
